import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faCalendarAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import { CalendarEvent } from 'angular-calendar';
import { AppointmentService } from 'src/app/services/appointment.service';
import { VoiceRecognitionService } from 'src/app/services/voice-recognition.service';
import { SidenavActions, SideNavService } from '../services/side-nav.service';
import { DataService } from 'src/app/services/data.service';
import * as moment from 'moment';
@Component({
  selector: 'app-appointments',
  templateUrl: './appointments.component.html',
  styleUrls: ['./appointments.component.scss']
})
export class AppointmentsComponent implements OnInit {
  loading = false;
  faPlus = faPlus;
  faCalendar = faCalendarAlt;
  sideNavActions = SidenavActions;
  public started = false;
  public message = '';
  appointmentRequests = [];
  locations = [];
  location: string = 'Bronkhorstspruit';
  constructor(private dataService: DataService, public sidenav: SideNavService, private appointmentService: AppointmentService, private router: Router, private voiceService: VoiceRecognitionService) {
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.voiceService.text = '';
    this.voiceService.speechToText.next('');
    this.appointmentService.appointmentRequests$.subscribe(res => this.appointmentRequests = res);
  }

  openSideNav(e: CalendarEvent): void {
    console.log(e)
    this.appointmentService.setAppointment(e);
    if(e.id){
      this.sidenav.open(this.sideNavActions.UpdateAppointment);
    } else {
      this.sidenav.open(this.sideNavActions.NewAppointment);
    }
  }

  updateLoader(e: boolean){
    this.loading = e;
  }

  reviewAppointmentRequest(appointmentRequest: any): void {
    const durationStringArray = appointmentRequest.appointmentDuration.split(' ');
    const event = {
        id: appointmentRequest.id,
        start: moment(appointmentRequest.appointmentDate).utcOffset('+0200').toDate(),
        end: moment(appointmentRequest.endTime).utcOffset('+0200').toDate(),
        title: appointmentRequest.summary +' - '+ appointmentRequest.clientName + (appointmentRequest.preferredPractitioner? ' - ' + appointmentRequest.preferredPractitioner.name  : ' - Any practitioner'),
        allDay: false,
        resizable: {
          beforeStart: true,
          afterEnd: true,
        },
        meta: {appointmentType: {summary: appointmentRequest.summary, duration: appointmentRequest.duration},description: appointmentRequest.description, id: appointmentRequest.id, clientEmail: appointmentRequest.clientEmail, clientName: appointmentRequest.clientName, appointmentLocation: appointmentRequest.appointmentLocation, businessName: appointmentRequest.businessName, preferredPractitioner: appointmentRequest.preferredPractitioner, additionalNotes: appointmentRequest.additionalNotes},
        draggable: true,
        cssClass: 'eventColor'+(appointmentRequest.colorId ? appointmentRequest.colorId : 1) 
      }
    this.openSideNav(event);
  }

}
